import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {ApplicationConfig, config} from "../../../../config";
import {IconComponent} from "../icon/icon.component";
import {TelevisionProduct} from "../../model/product.model";
import {DividerComponent} from "../divider/divider.component";


@Component({
  selector: 'app-television-details-display',
  imports: [
    DividerComponent,
    IconComponent
  ],
  templateUrl: './television-details-display.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './television-details-display.component.scss'
})
export class TelevisionDetailsDisplayComponent {
  public isPasswordVisible: boolean = false;
  @Input() product: TelevisionProduct | null = null;

  protected readonly config: ApplicationConfig = config;

  public togglePassword(): void {
    this.isPasswordVisible = !this.isPasswordVisible;
  }
}
